import React from "react";
import Accordion from "../../../../elements/Accordian";

const HomeFaq = () => {
  const faqData = [
    {
      title: "When will my documents be verified?",
      content: (
        <p>
          Document verification typically takes between 24 to 48 hours, depending
          on the volume of requests and the accuracy of the submitted information.
          We'll notify you via email or in-app as soon as your documents are reviewed.
          To avoid delays, ensure that all uploads are clear, valid, and match your account details.
        </p>
      ),
    },
    {
      title: "Document verification timeline explained",
      content: <p>Here’s a breakdown of how the timeline works…</p>,
    },
    {
      title: "When can I expect my documents to be approved?",
      content: <p>Approval usually follows within 48 hours once reviewed…</p>,
    },
    {
      title: "Understanding your document verification status",
      content: <p>Statuses include pending, under review, or verified…</p>,
    },
    {
      title: "Why is my document still under review?",
      content: <p>Sometimes reviews take longer due to high request volumes…</p>,
    },
    {
      title: "Your document verification – what happens next?",
      content: <p>After submission, our team validates authenticity…</p>,
    },
    {
      title: "Tracking your document verification progress",
      content: <p>You can track progress via your account dashboard…</p>,
    },
    {
      title: "Verification delays? Let’s clarify",
      content: <p>Delays can happen if uploads are unclear or mismatched…</p>,
    },
    {
      title: "Still waiting? Here’s how document verification works",
      content: <p>Verification ensures compliance and account safety…</p>,
    },
    {
      title: "Hang Tight – We’re Verifying Your Documents",
      content: <p>No action is required, we’ll notify you soon…</p>,
    },
  ];

  return (
    <section className="relative pt-32 pb-36">
      <div className="w-full max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="text-[40px] xl:text-[56px] font-semibold text-white max-w-[550px] w-full leading-[50px] xl:leading-[70px]">
            Stuck somewhere? Let us guide you.
          </h2>
        </div>
        <Accordion
          data={faqData}
          className="!bg-transparent"
          buttonClass="!bg-transparent text-white rounded-none px-0 py-4 font-medium text-[22px] leading-[34px] font-Poppins !border-0"
          contentClass="font-Poppins text-lg leading-[34px] text-[#E8E4E4] px-0 pb-8"
          bodyClass={"!bg-transparent"}
          wrapperClass={"border-b border-gray-700 mb-5 last:border-b-0 last:mb-0"}
        />
      </div>
    </section>
  );
};

export default HomeFaq;